// Runtime config for the WeeBee Chat mini app. The app is intentionally tiny —
// it holds no Firebase/App Check (unlike the tickets app); the signed view token
// carried in the /t/<token> URL is the sole credential.
export const config = {
  /** weebee backend base URL — serves GET /api/v1/chat/ticket. */
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  environment: import.meta.env.VITE_ENVIRONMENT ?? 'development',
  /** App-shell service worker (offline cold-load) — off unless explicitly enabled. */
  swEnabled: import.meta.env.VITE_CHAT_SW_ENABLED === 'true',
  /**
   * Deep link back to the WeeBee WhatsApp business chat. The app opens inside
   * WhatsApp's in-app browser with no history entry, so "back to chat" buttons
   * navigate here (a wa.me link reliably reopens the chat on iOS + Android)
   * rather than calling history.back() (a no-op) or window.close() (blocked on
   * iOS). Overridable per-env via VITE_WHATSAPP_URL; defaults to the WeeBee
   * business number (+1 555 922-7738).
   */
  whatsappUrl: import.meta.env.VITE_WHATSAPP_URL ?? 'https://wa.me/15559227738',
} as const;
